import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function GlitchTransition() {
  const location = useLocation();
  const [isGlitching, setIsGlitching] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    setIsGlitching(true);
    setIsFading(false);

    const fadeTimer = setTimeout(() => {
      setIsFading(true);
    }, 800);

    const unmountTimer = setTimeout(() => {
      setIsGlitching(false);
    }, 1800);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(unmountTimer);
    };
  }, [location.pathname, location.key]);

  if (!isGlitching) return null;

  const logoSrc = process.env.PUBLIC_URL + '/images/logo/logo-spss-2026.png';

  return (
    <div
      className="vhs-glitch-overlay pointer-events-none"
      aria-hidden="true"
      style={{
        opacity: isFading ? 0 : 1,
        transition: 'opacity 700ms cubic-bezier(0.25, 1, 0.5, 1)',
        willChange: 'opacity',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className="vhs-scanlines" />
      <div className="vhs-tracking-bar" />
      <div className="vhs-color-bars" />
      <div className="vhs-static-noise" />

      {/* Center Logo Container: Anchored dead-center via absolute translation */}
      <div
        className="vhs-logo-container"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          margin: 0,
        }}
      >
        <img src={logoSrc} alt="" className="vhs-logo vhs-logo-blue" />
        <img src={logoSrc} alt="" className="vhs-logo vhs-logo-red" />
        <img src={logoSrc} alt="" className="vhs-logo vhs-logo-main" />
      </div>
    </div>
  );
}